import CONST from './model/const'
import App from './app'

export default {
  VHall_Questionnaire_Service: App,
  VHall_Questionnaire_Const: CONST
}
